module.exports = __webpack_public_path__ + "static/media/M002-account-noprivilege.405f4ba2.svg";